// Single source for the Terms version the sign-up form sends. Mirrors
// backend/tableyze/legal.py; bump both together when the Terms or the AUP
// change materially. The status date shown on every legal page.
export const TERMS_VERSION = '2026-10-06';
export const LEGAL_STATUS_DATE = '6 October 2026';
